<template>
  <html-report
    :header="false"
    style="
    page-break-inside: avoid;
    page-break-after: always;
    clear: both;"
    :pageSize="pageSize"
  >
    <div>
      <div>
        <div>
          <img :src="logo" alt="logo_operadora" width="60mm" height="60mm" />
        </div>
        <br><br>
        <div class="text-center mt-4" :style="pageSize == 'A5' ? 'width: 80%;' : ''">
          <p class="font-weight-bold" style="font-size:22px;">{{ title }}</p>
        </div>
        <br>
        <div class="mx-4" :style="pageSize == 'A5' ? 'width: 80%;' : ''">
          <!-- Texto -->
          <p style="text-align:justify; font-size:16pt;">{{ texto }}</p>
          <br>
          <strong style="text-align:justify; font-size: 16px;" v-if="cid ? cid : ''">CID:{{ cid }}</strong>
        </div>
      </div>
    </div>

    <template v-slot:rodape v-if="medico">
      <p>{{ cidade }}, {{ dataAtual }}</p>
      <rodape-medico :medico="medico" />

      <br><br>
      <p>{{ endereco }}</p>
      <p>{{ cep }}</p>
      <p>{{ telefones }}</p>
    </template>
  </html-report>
</template>

<script>
import * as moment from "moment";
import HtmlReport from "../../relatorios/HTMLReport";
import RodapeMedico from '../../relatorios/consultorio/RodapeMedico.vue';

export default {
  props: {
    texto: String,
    marcacao: Object,
    type: {
      type: String,
      default: "paciente"
    },
    cid: {
      type: String,
      default: ""
    },
    unidade: {
      type: Object
    },
    pageSize: {
      type: String,
      default: "A5"
    },
    medico: { 
      type: Object
    }
  },
  components: {
    HtmlReport,
    RodapeMedico
  },
  data() {
    return {};
  },
  computed: {
    cidade() {
      return ( this.$store.state.unidade.endereco && this.$store.state.unidade.endereco.cidade ) ? this.$store.state.unidade.endereco.cidade.st_cidade : "";
    },
    dataAtual() {
      return moment().format("DD/MM/YYYY");
      // return moment.format();
    },
    medico2() {
      return this.marcacao &&
        this.marcacao.medico &&
        this.marcacao.medico.st_nome_exibicao
        ? this.marcacao.medico.st_nome_exibicao
        : null;
    },
    crefito() {
      return this.marcacao &&
        this.marcacao.medico &&
        this.marcacao.medico.in_numero_conselho
        ? this.marcacao.medico.in_numero_conselho
        : null;
    },
    title() {
      return this.type == "paciente"
        ? "ATESTADO DE COMPARECIMENTO"
        : this.type == "acompanhante"
        ? "ATESTADO DE ACOMPANHAMENTO"
        : "ATESTADO MÉDICO";
    },
    endereco() {
      let enderecoTexto = "";
      if (this.unidade && this.unidade.endereco) {
        if (this.unidade.endereco.st_logradouro) {
          enderecoTexto += " " + this.unidade.endereco.st_logradouro;
          if (this.unidade.endereco.st_numero)
            enderecoTexto += ", " + this.unidade.endereco.st_numero;
        }
        if (this.unidade.endereco.st_bairro)
          enderecoTexto += " Bairro: " + this.unidade.endereco.st_bairro;
        // if (this.unidade.endereco.in_cep)
        //   enderecoTexto += "Cep: " + this.unidade.endereco.in_cep;
        // if (
        //   this.unidade.endereco.cidade &&
        //   this.unidade.endereco.cidade.st_cidade
        // )
        //   enderecoTexto += " - " + this.unidade.endereco.cidade.st_cidade;
      }
      return enderecoTexto;
    },
    cep() {
      let cepTxt = "";
      if (this.unidade && this.unidade.endereco) {
        if (this.unidade.endereco.in_cep)
          cepTxt += "Cep: " + this.unidade.endereco.in_cep;
        if (
          this.unidade.endereco.cidade &&
          this.unidade.endereco.cidade.st_cidade
        )
          cepTxt += " - " + this.unidade.endereco.cidade.st_cidade;
      }
      return cepTxt;
    },
    telefones() {
      let telefonesTexto = "";
      if (this.unidade && this.unidade.telefone_unidades) {
        this.unidade.telefone_unidades.forEach(item => {
          telefonesTexto +=
            this.$util.formatMask(item.telefone.st_numero, "tel") + " ";
        });
      }
      return telefonesTexto;
    },
    logo() {
      let logoURL = "";
      if (this.unidade && this.unidade.logo) {
        logoURL = this.unidade.logo.arquivo.temporary_url;
      }
      return logoURL;
    }
  },
  mounted() {}
};
</script>

<style></style>
